/**
 * Shared intake-vs-target colors for meal-plan Analyse drawer and Nutrient Report progress bars.
 * Delegates to the Suggested RDA palette in `suggestedRdaTone.ts`.
 */
import {
  getSuggestedRdaBarColorFromPercent,
  getSuggestedRdaIntakeStatus,
  suggestedRdaToneStyles,
} from '@/clients/details/v2/components/analysis/suggestedRdaTone';

export const NUTRITION_TRAFFIC_LIGHT = {
  green: suggestedRdaToneStyles.met.bar,
  amber: suggestedRdaToneStyles.borderline.bar,
  red: suggestedRdaToneStyles.deficient.bar,
} as const;

export const getNutritionTrafficLightColor = getSuggestedRdaBarColorFromPercent;

/** Color + label for analysis UI (KPI strip, macro distribution card). */
export function getNutritionTrafficLightStatus(percent: number): { color: string; label: string } {
  const { color, label } = getSuggestedRdaIntakeStatus(percent);
  return { color, label };
}
